import { SvgIcon, SvgIconProps } from "@mui/material";

export const ReportsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M22.154 24.5h-14a2.333 2.333 0 0 1-2.334-2.333V5.833A2.333 2.333 0 0 1 8.154 3.5h14a2.333 2.333 0 0 1 2.333 2.333v16.334a2.333 2.333 0 0 1-2.333 2.333Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M11.643 9.333h8.167M11.643 18.672h8.167M11.643 13.995h8.167M4.07 9.333h3.5M4.07 18.672h3.268M4.07 13.995h3.268"
      />
    </svg>
  </SvgIcon>
);
